<!-- 产品-设备重复详情 -->
<template>
  <div class="md-layout">
    <!-- 卡片-设备重复详情表格 -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <!-- 卡片-主体-查询表单 -->
          <div class="md-layout card-form" style="max-width: 700px;">
              <!-- 表单-选择栏-数据类型 {uid: UID, mac: MAC} -->
              <div class="md-layout-item md-size-25 left-layout-item md-xsmall-size-50">
                <md-field>
                  <md-select v-model="searchForm.searchType" >
                    <md-option value="uid">{{$I18n('search_by_uid')}}</md-option>
                    <md-option value="mac">{{$I18n('search_by_mac')}}</md-option>
                  </md-select>
                </md-field>
              </div>
              <!-- 表单-输入栏-查询参数 (和上面的选择相绑定) -->
              <div class="md-layout-item md-size-25 left-layout-item md-xsmall-size-50">
                <md-field>
                  <label v-if="searchForm.searchType === 'uid'">UID</label>
                  <label v-if="searchForm.searchType === 'mac'">MAC</label>
                  <md-input v-model="searchForm.searchValue"/>
                </md-field>
              </div>
              <!-- 表单-按钮 (只在小屏幕模式下显示) -->
              <div class="md-layout-item md-size-50">
                <md-button class= "left-icon md-info" @click="form_changeSearchData">
                  <md-icon>search</md-icon>{{$I18n("search")}}
                </md-button>
              </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <!-- 卡片-主体-表格
            体系
            所属企业
            UID
            MAC
            IP
            所属区域
            状态 {1:待处理, 2:已处理}
            更新时间
            创建时间
            操作 {修改该设备}
           -->
          <md-table v-model="tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('batch_id')">{{ item.batch_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('state')">{{ item.dev_state }}</md-table-cell>
              <md-table-cell :md-label="'UID'">{{ item.lic_code }}</md-table-cell>
              <md-table-cell :md-label="'MAC'">{{ item.grant_mac }}</md-table-cell>
              <md-table-cell :md-label="$I18n('created_thing_time')">{{ item.create_date }}</md-table-cell>
              
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
      </md-card>
    </div>
  </div>
</template>
<script>
import { timestampToString1000 } from "@/common/tools.js";
export default {
  data() {
    return {
      searchForm : { // 表单-筛选表格的查询表单
        searchType : "uid",
        searchValue: "",
        state : "0",
      },
      searchData : { // API-筛选表格的查询数据
        grant_mac : "",
        lic_code  : "",
      },
      tableInitData : [], // 表格数据
      compData : [], // 公司数据
      // 分页相关
      pageSize    : 10,
      currentPage : 1,
      total       : 0,
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: {
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPage() {
      this.api_getPageData();
    },
  },
  methods: {
    api_getPageData(){ // API-获取页面信息
      // 获取角色
      let page_no = this.currentPage;
      this.$api.getLicList({
          ...this.searchData,
          page_size: this.pageSize,
          page_no: this.currentPage,
      })
        .then(this.$Then(res => {
          if (page_no !== this.currentPage) {
            return;
          }
          this.total = res.count;
          this.tableInitData = res.data.map(item => {
            return {
              ...item,
              ver: item.ver ?item.ver :"",
            };
          });
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.total = 0;
          this.tableInitData = [];
        }))
    },
    // 更改查询条件(并立刻查询)
    form_changeSearchData () {
      this.currentPage = 1;
      this.searchData = {
        grant_mac : this.searchForm.searchType === "mac" ?this.searchForm.searchValue :"",
        lic_code  : this.searchForm.searchType === "uid" ?this.searchForm.searchValue :"",
      };
      this.api_getPageData();
    },
  },
  computed: {
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return this.tableInitData.map(item => {
          // 状态
          let dev_state = this.$I18n('normal')
          switch(item.auth_state){
            case "1":
            case 1:
              dev_state = this.$I18n("fail_num");
              break;
          }
          let type_name = this.$I18n("unknow");
          switch(item.lic_type){
            case "1":
            case 1:
              type_name = this.$I18n("umid_type");
              break;
            case "2":
            case 2:
              type_name = this.$I18n("code_type");
              break;
            case "4":
            case 4:
              type_name = this.$I18n("mac_type");
              break;
          }

          return {
            dev_state,
            type_name,
            create_date: timestampToString1000(item.gmt_create),
            ... item,
          }
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 60px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }
</style>
